<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Теги <span class="data-rows-number">{{ tagsTotal }}</span></h1>
      <q-btn
        @click="createTag()"
        color="primary"
        class="q-mt-sm"
      >
        Новый тег
      </q-btn>
    </div>
    <tags-list ref="tagsList"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TagsList from '@/TagsList';
  import api from 'mixins/api';
  import {
    QBtn
  } from 'quasar';
  
  export default {
    name: 'TagsView',
    components: {
      QBtn,
      TagsList
    },
    mixins: [
      api
    ],
    data () {
      return {
        newUser: false
      };
    },
    computed: mapGetters({
      tagsTotal: 'tagsList/total'
    }),
    methods: {
      createTag () {
        this.$q.dialog({
          title: 'Новый тег',
          color: 'primary',
          ok: true,
          cancel: true,
          prompt: {
            model: '',
            type: 'text'
          }
        }).then(data => {
          this.api.post(`tags`, {
            'name': data
          }).then(() => {
            this.$refs.tagsList.updateTags();
          }).catch(error => {
            console.error(error);
          });
        });
      },
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/TagsView.vue